import repository from './repsitory'

const resource = '/gameLine'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addGameLine (data) {
        return repository.post(`${resource}`, data)
    },
    updateGameLine (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
